import {config} from '../config/config';
export default class User {
  private url: string = config.armcareServerUrl;

  public GetUserCredentials(): object {
    const data = JSON.parse(localStorage.getItem('user') as string);
    if (data?.access_token) {
      return {status: true, data};
    } else {
      return {status: false};
    }
  }

  public async GetUserData(credentials = this.GetUserCredentials() as any): Promise<unknown> {
    const token = credentials.data.access_token;
    try {
      const response = await fetch(`${this.url}/api/v2/user`, {
        method: 'GET',
        headers: new Headers({
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        }),
      });
      const data = await response.json();
      if (data?._id) {
        return {status: true, data};
      } else {
        return {status: false};
      }
    } catch (e) {
      return {status: false};
    }
  }
}
